module.exports = __webpack_public_path__ + "img/indicate_icon_5.27fd106c.png";